/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupslinkreset2Inputs */

const en_groupslinkreset2 = /** @type {(inputs: Groupslinkreset2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create new link`)
};

const de_groupslinkreset2 = /** @type {(inputs: Groupslinkreset2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuen Link erstellen`)
};

/**
* | output |
* | --- |
* | "Create new link" |
*
* @param {Groupslinkreset2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupslinkreset2 = /** @type {((inputs?: Groupslinkreset2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupslinkreset2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupslinkreset2(inputs)
	return de_groupslinkreset2(inputs)
});
export { groupslinkreset2 as "groupsLinkReset" }